import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {ValidationErrors, FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {BehaviorSubject, Observer, Observable} from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import {UserService, AppsService, ResourceService} from "@ecip/service";
import {CacheService} from "@delon/cache";

@Component({
  selector: 'app-system-resource-edit',
  templateUrl: './edit.component.html',
})
export class SystemResourceEditComponent implements OnInit {
  record: any = {};
  i: any;
  appId: any;
  isRoot: boolean;
  isViewpermission: boolean = false;
  form: FormGroup;
  defaultpermission: boolean = false;
  parent;

  loading: boolean = false;
  stateList = this.cacheService.get(`api/dict/type/enableState`);
  typeSrcList = this.cacheService.get(`api/dict/type/typeSrc`);
  urlTargetList = this.cacheService.get(`api/dict/type/urlTarget`);
  typeNodeList = this.cacheService.get(`api/dict/type/typeNode`);

  typeSrc: any;
  urlTarget: any;
  typeNode: any;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public resourceService: ResourceService,
    public userService: UserService,
    public appsService: AppsService,
    public http: _HttpClient,
    private fb: FormBuilder,
    private cacheService: CacheService
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    /*this.appsService.getList().subscribe(appList => {
      this.optionList = appList;
    });*/
    this.typeSrcList.subscribe(res => {
      if (res) {
        this.typeSrc = res[0];
      }
    });
    this.urlTargetList.subscribe(res => {
      if (res) {
        this.urlTarget = res[0];
      }
    });
    this.typeNodeList.subscribe(res => {
      if (res) {
        this.typeNode = res[0];
      }
    });
    let flagBreadcrumb ;
    let flagMenuGroup;
    let nodeLevel;
    let pid = null;
    let path = '';
    if (!this.record.id) {
      if (this.isRoot) {
        nodeLevel = 0;
        flagBreadcrumb = false;
        flagMenuGroup = true;
      } else {
        this.isViewpermission = this.parent.typeNode !== 2;
        flagBreadcrumb = true;
        flagMenuGroup = false;
        pid = this.parent.id;
        let parentPath = this.parent.path;
        if (!parentPath) { //idéå·åéï¼ä»ä¸å°ä¸
          path = `,${this.parent.id},`;
        } else {
          path = `,${this.parent.id}${this.parent.path}`;
        }

        nodeLevel = this.parent.nodeLevel + 1;
      }

    }else{
      this.isViewpermission = this.record.typeNode !== 2;
    }


    this.form = this.fb.group({
      appId: [this.appId, []],
      code: [null, [Validators.required], [this.codeAsyncValidator]],
      rsrcName: [null, [Validators.required]],
      deptId: [null, []],
      pid: [pid, []],
      path: [path, []],
      typeSrc: [this.typeSrc ? this.typeSrc.value : '', [Validators.required]],
      typeNode: [this.typeNode ? this.typeNode.value : '', [Validators.required]],
      url: [null, []],
      urlTarget: [this.urlTarget ? this.urlTarget.value : '', []],
      rsrcIcon: [null, []],
      rsrcStatus: [1, [Validators.required]],
      flagBreadcrumb: [flagBreadcrumb, [Validators.required]],
      flagMenuGroup: [flagMenuGroup, [Validators.required]],
      sortNm: [0, [Validators.required]],
      permission: [null, []],
      beginTime: [null, []],
      endTime: [null, []],
      nodeLevel: [nodeLevel, []],
      defaultpermission: [false, [Validators.required]],
    });

    if (!this.record.id) {
      return;
    }
    this.resourceService.getById(this.record.id).subscribe((res:any) => {
      this.form.patchValue(res);
      // this.form.patchValue({code: res.code});
      this.i = res;
    });
  }

  compareNumStr(c1: any, c2: any): boolean {
    return c1 == c2;
  }

  codeAsyncValidator = (control: FormControl) =>
    Observable.create((observer: Observer<ValidationErrors>) => {
      if (!control.value) {
        observer.next(null);
        observer.complete();
        return;
      }
      this.resourceService.checkCode({code: control.value, id: this.record.id}).subscribe((res:any)=> {
        if (res.valid === true) {
          observer.next(null);
        } else {
          observer.next({ error: true, duplicated: true });
        }
        observer.complete();
      });
    });

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    if (!this.record.id) {
      //æ°å¢
      this.resourceService.post(this.form.value).subscribe((res: any) => {
        this.msgSrv.success('ä¿å­æå');
        if(this.form.value.defaultpermission){
          this.resourceService.addDefaultPermission(res).subscribe((data: any) => {
            res.children = [];
            data.forEach(it => {
              res.children.push(it);
            });
          });
        }
        this.modal.close(res);
      });
      return;
    }
    //ä¿®æ¹
    this.resourceService.put(this.record.id, this.form.value ).subscribe( (res: any) => {
      this.msgSrv.success('ä¿å­æå');
      // æ¯å¦æ°å¢é»è®¤æé
      if(this.form.value.defaultpermission){
        // æ°å¢é»è®¤æé
        this.resourceService.addDefaultPermission(res).subscribe(() => {});
      }
      this.modal.close({result: res, addFlag: this.form.value.defaultpermission});
    });
  }

  close() {
    this.modal.destroy();
  }
}
